export default {
  props: {
    item: Object // see public news
  }
}
